import useTranslate from 'hooks/useTranslate';
import { Button, Modal } from 'react-bootstrap';

interface ConfirmModalProps {
	showConfirm: boolean;
	handleModalVisibility: any;
	handleModalConfirm: any;
	slug?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
	showConfirm,
	handleModalVisibility,
	handleModalConfirm,
	slug = '',
}) => {
	const { translate } = useTranslate();
	return (
		<Modal
			dialogClassName="build-resume-modal"
			show={showConfirm}
			onHide={() => handleModalVisibility(slug)}
			centered
		>
			<Modal.Header className="border-0 pt-4 px-4">
				<h4 className="fw-bold mb-0">{translate('Template.deleteEntry')}</h4>
			</Modal.Header>
			<Modal.Body className="border-0 px-4">
				<p>{translate('Template.confirmDeleteMsg')}</p>
			</Modal.Body>
			<Modal.Footer className="border-0 px-4 justify-content-start gap-2">
				<Button
					className="transparent-btn rounded-pill"
					variant="secondary"
					onClick={() => handleModalVisibility(slug)}
				>
					{translate('Template.cancel')}
				</Button>
				<Button className="filled-btn rounded-pill" variant="primary" onClick={handleModalConfirm}>
					{translate('Template.delete')}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmModal;
